import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './container/redux/store';
import { setLogOut as studentLogOut } from './container/redux/userSlice';
import { setLogOut as affiliateLogOut } from './container/redux/affiliateSlice';
import { registerAuthInvalidHandlers } from './container/helper/authSession';

import { WebSocketProvider } from './context/socketContext';

registerAuthInvalidHandlers({
  student: () => store.dispatch(studentLogOut()),
  affiliate: () => store.dispatch(affiliateLogOut()),
});



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>

      <WebSocketProvider>

      <App />

      </WebSocketProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
